import { render, staticRenderFns } from "./harbour.vue?vue&type=template&id=76972816&scoped=true"
import script from "./harbour.vue?vue&type=script&lang=js"
export * from "./harbour.vue?vue&type=script&lang=js"
import style0 from "./harbour.vue?vue&type=style&index=0&id=76972816&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76972816",
  null
  
)

export default component.exports